import React, {useEffect} from "react"
import {useDispatch} from "react-redux"
import _ from "lodash"
import RefDbContainer from "./components/RefDbContainer"
import keycloak from "../keycloak"
import {
    getRolesSuccessAction,
    getUserSuccessAction,
} from "../core/actions/core.actions"
import licenceService from "./components/LicenceService"
import env from "../context/Env"
import {generalSettingsActions} from "../settings/redux/actions/settings.actions"

const RefDb = (): JSX.Element => {
    const dispatch = useDispatch()
    const roles =
        keycloak.resourceAccess &&
        keycloak.resourceAccess[`${env("KEYCLOAK_CLIENT_ID")}`]
            ? keycloak.resourceAccess[`${env("KEYCLOAK_CLIENT_ID")}`].roles
            : []
    if (!_.isUndefined(roles) && !_.isEmpty(roles)) {
        dispatch(getUserSuccessAction(licenceService.isOnlyInternal(roles)))
        dispatch(getRolesSuccessAction(roles as any))
    }

    useEffect(() => {
        if (
            !licenceService.isWithOutLicence(roles) &&
            licenceService.isEulaAccepted(roles)
        ) {
            dispatch(generalSettingsActions.getAllSettings())
        }
    }, [])

    return <RefDbContainer />
}

export default RefDb
